"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPin = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LocationPin = () => {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256" }, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: "128", cy: "104", r: "32", fill: "none", stroke: "currentcolor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "24" }), (0, jsx_runtime_1.jsx)("path", { d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z", fill: "none", stroke: "currentcolor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "24" })] })));
};
exports.LocationPin = LocationPin;
